<template>
  <div
    class="modal fade"
    id="privacy-global-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="termsLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4
            class="modal-title"
            id="termsLabel"
            v-html="privacyData.title ? privacyData.title : potentialPrivacyData.title"
          ></h4>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        </div>
        <div class="modal-body modal-body-min">
          <div class="article-body">
            <div class="mt-5">
              <p v-if="privacyData.description" v-html="privacyData.description"></p>
              <p v-if="privacyData.content" v-html="privacyData.content"></p>
            </div>

            <div class="mt-5">
              <p v-if="potentialPrivacyData.description" v-html="potentialPrivacyData.description"></p>
              <p v-if="potentialPrivacyData.content" v-html="potentialPrivacyData.content"></p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn_1" data-dismiss="modal">{{ $t('Kapat') }}</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
  <!-- Modal terms -->
</template>
<script>
export default {
  name: 'PrivacyGlobalModal',
  created() {
    this.getPolicy();
  },
  data() {
    return {
      privacyData: {
        title: null,
        description: null,
        content: null,
      },
      potentialPrivacyData: {
        title: null,
        description: null,
        content: null,
      },
    };
  },
  props: {
    isCustomer: {
      type: Boolean,
      default: false,
    },
    isConnectCompany: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    '$i18n.locale': function () {
      this.getPolicy();
    },
  },
  methods: {
    getTosPolicy() {
      if (this.isCustomer || this.$i18n.locale !== 'tr') {
        const endPoints = {
          tr: this.isConnectCompany ? 'policy/connect-musteri-gizlilik' : 'policy/musteri-gizlilik',
          en: this.isConnectCompany ? 'policy/connect-workhy-privacy' : 'policy/workhy-privacy',
          pt: 'policy/workhy-privacy',
        };

        return $axios.get(endPoints[this.$i18n.locale]);
      }
      return null;
    },
    getpotentialTosPolicy() {
      if (this.$i18n.locale === 'tr' && !this.isCustomer) {
        return $axios.get('policy/potansiyel-musteri-gizlilik');
      }
      return null;
    },
    getPolicy() {
      $axios.all([this.getTosPolicy(), this.getpotentialTosPolicy()]).then(
        $axios.spread((privacyResponse, potentialPrivacyResponse) => {
          if (privacyResponse) {
            const privacyData = privacyResponse.data.data;

            this.privacyData = {
              title: privacyData.title,
              description: privacyData.description,
              content: privacyData.content,
            };
          }

          if (potentialPrivacyResponse) {
            const potentialPrivacyData = potentialPrivacyResponse.data.data;
            this.potentialPrivacyData = {
              title: potentialPrivacyData.title,
              description: potentialPrivacyData.description,
              content: potentialPrivacyData.content,
            };
          }
        })
      );
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 800px !important;
  padding: 8px !important;
}
</style>
